import { type FC, type ReactNode } from "react";
import InlineSelect from "../../../InlineSelect/InlineSelect";

interface Props {
    options: Array<{ label: ReactNode; value: string; }>;
    value: string;
    onChange: (value: string) => void;
}

export const StyleInlineSelect: FC<Props> = ({
    options,
    value,
    onChange,
}) => {
    return (
        <InlineSelect
            options={options.map(option => option.label)}
            selected={options.findIndex(option => option.value === value)}
            onSelect={index => {
                onChange(options[index].value);
            }}
        />
    );
};
